import React, { useState, Fragment } from "react";

import useGet from "../../hooks/useGet";
import Loading from "../Loading";
import DiseaseList from "./DiseaseList";
import Error from "./Error";
import { groupPostsByLetter } from "../../helpers/groupByLetter";
import AlphabetFilters from "./filters/Alphabet";
import Checkbox from "./filters/Checkbox";

const apiUrl = "/wp-json/salesforce/v1/funds";

const Diseases = () => {
  let activeLetters = [];
  let hasReEnrollment = false;
  let hasWaitListOnly = false;

  const [letter, setLetter] = useState("");
  const [open, setOpen] = useState(true);
  const [closed, setClosed] = useState(true);
  const [reEnrollment, setReEnrollment] = useState(true);
  const [waitListOnly, setWaitListOnly] = useState(true);

  const [loading, response, error] = useGet(apiUrl);

  if (response && !loading && typeof response.data == "object" && response.data.funds) {
    activeLetters = Object.keys(groupPostsByLetter(response.data.funds));

    // Loop over data, if any of the funds are for re-enrollment only set
    // hasReEnrollment to true, conditionally toggling an additional filter
    // and labels
    for (const fund of response.data.funds) {
      if (fund.Fund_Status === "Open" && fund.IsRenewalOnly) {
        hasReEnrollment = true;
      }

      if (fund.Fund_Status === "Closed, wait list available") {
        hasWaitListOnly = true;
      }
    }
  }

  return (
    <Fragment>
      <form
        // FIXME-799
        // className={`ListingFilters u-form ${
        //   hasReEnrollment ? "ListingFilters--hasReEnrollment" : ""
        // }`}
        className={`ListingFilters u-form`}
      >
        <div className="l-padding">
          <div className="ListingFilters-wrap l-wrap">
            <AlphabetFilters
              activeLetters={activeLetters}
              setLetters={setLetter}
              // FIXME-799
              // showLegend={hasReEnrollment}
              letter={letter}
            />

            <div className="ListingFilters-group ListingFilters-group-checkboxesWrapper">
              <div className="ListingFilters-checkboxes">
                <fieldset>
                  {/* FIXME-799 */}
                  {/* {hasReEnrollment && (
                    <legend className="f-label-small"> All Applicants</legend>
                  )} */}

                  <Checkbox
                    id="disease-fund-open"
                    label="Open"
                    bool={open}
                    setBool={setOpen}
                    infoMessage="We are accepting applications for new and renewal patients"
                  />
                  <Checkbox
                    id="disease-fund-closed"
                    label="Closed"
                    bool={closed}
                    setBool={setClosed}
                    infoMessage="We are no longer accepting applications for new or renewal patients."
                  />
                  <Checkbox
                    id="wait-list-only"
                    label="Wait List"
                    bool={waitListOnly}
                    setBool={setWaitListOnly}
                    infoMessage="We are currently reviewing wait list applications."
                  />
                </fieldset>
                {/* FIXME-799 */}
                {/* {hasReEnrollment && (
                  <fieldset>
                    <legend className="f-label-small">Existing Patients</legend>
                    <Checkbox
                      id="disease-fund-waitlist"
                      label="Re-enrollment only"
                      bool={reEnrollment}
                      setBool={setReEnrollment}
                      infoMessage="We are accepting applications from existing patients for renewal or second grants only."
                    />
                  </fieldset>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </form>

      <div className="l-padding">
        <div className="l-wrap">
          {loading && <Loading label="Searching..." />}

          {response && !loading && (
            <DiseaseList
              letter={letter}
              open={open}
              closed={closed}
              reEnrollment={reEnrollment}
              waitListOnly={waitListOnly}
              displayStatus={true}
              results={response && !loading ? response.data.funds : null}
            />
          )}

          {error && <Error />}
        </div>
      </div>
    </Fragment>
  );
};

export default Diseases;
